module.exports = __webpack_public_path__ + "static/media/register_header.3417d104.png";